import { render, staticRenderFns } from "./availableProvider2FA.vue?vue&type=template&id=2986046b&scoped=true&"
import script from "./availableProvider2FA.vue?vue&type=script&lang=js&"
export * from "./availableProvider2FA.vue?vue&type=script&lang=js&"
import style0 from "./availableProvider2FA.vue?vue&type=style&index=0&id=2986046b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986046b",
  null
  
)

export default component.exports